const home = {
  hero: {
    eyebrow: 'Vinski Vrh · Miklavž pri Ormožu',
    title: 'Črna Kuhna',
    tagline: 'From the fire. From Prlekija. For the shared table.',
    lead: 'A restaurant where everything begins in the bread oven — seasonal Prlekija cooking, house wines and hospitality around the shared table.',
    ctaReserve: 'Book a table',
    ctaMenu: 'View menu',
    linksNote: 'Click the links below for more information',
    photoLabel: 'Place for the hero photograph — the bread oven or food being prepared',
    scrollHint: 'Scroll',
  },
  fire: {
    label: 'Fire',
    title: 'Cooking that starts with the fire',
    text: 'At the heart of our kitchen is the bread oven. The warmth of embers, slow roasting and the scent that fills the room — everything that reaches the table carries a trace of the fire.',
    photoLabel: 'Photograph — fire in the bread oven',
  },
  grill: {
    label: 'Grill',
    title: 'Cooking over an open fire',
    text: 'Some dishes need nothing more than fire, embers and patience. On the open grill, meat and vegetables roast slowly, while the smoke adds the final layer of flavour.',
    photoLabel: 'Photograph — a grill with an open fire',
  },
  seasonal: {
    label: 'Seasons',
    title: 'Whatever the season gives',
    text: 'The kitchen follows the seasons and the Prlekija soil. We choose ingredients when they are at their best, so the menu changes through the year.',
    photoLabel: 'Photograph — seasonal ingredients',
  },
  dishes: {
    label: 'From the table',
    title: 'Selected dishes',
    text: 'The dishes we prepare grow out of the fire, the season and home tradition. We tell you exactly what is on the plate — no inventions.',
    ctaMenu: 'View menu',
    note: 'The seasonal menu changes. Please check the current offer by phone.',
    photoLabel: 'Photograph — a dish from the table',
  },
  wines: {
    label: 'In the glass',
    title: 'Glavinič house wines',
    text: 'The best wine with a meal is the one growing right beside it. That is why we serve the Glavinič house wines from the Prlekija vineyards.',
    ctaWines: 'More about the wines',
    photoLabel: 'Photograph — a glass of wine or the vineyards',
  },
  space: {
    label: 'Space',
    title: 'The space and the experience',
    text: 'A welcoming place where the table is shared, the glass is poured and the day slows down. The Prlekija landscape is part of every visit.',
    photoLabel: 'Photograph — the space or interior',
    feature1: 'A table shared between guests',
    feature2: 'A glass poured with the right dish',
    feature3: 'Time that slows down over conversation',
  },
  galleryPreview: {
    label: 'Moments',
    title: 'From our table and our space',
    text: 'A few glimpses of Črna Kuhna — fire, dishes, space and wine. You will find more photographs in the gallery.',
    cta: 'View the gallery',
  },
  location: {
    label: 'Location',
    title: 'Among the vineyards of Prlekija',
    text: 'You will find us at Vinski Vrh near Miklavž pri Ormožu, among the hills and vineyards. The button below opens directions to us.',
    ctaDirections: 'Open directions',
    photoLabel: 'Photograph — vineyards or landscape',
  },
  hours: {
    label: 'Winter opening hours',
    title: 'Winter opening hours',
    note: 'For larger groups and special occasions, please call us.',
    rows: [
      { day: 'Monday–Thursday', time: 'Closed' },
      { day: 'Friday–Saturday', time: '12:00–22:00' },
      { day: 'Sunday', time: '12:00–17:00' },
    ],
  },
  reserve: {
    label: 'Reservation',
    title: 'Come to the shared table',
    text: 'Booking a table is quick — online, by phone or by email. We look forward to your visit.',
    cta: 'Book a table',
    callLabel: 'Phone',
    emailLabel: 'Email',
  },
};

export default { home };